import { jsx as _jsx } from "preact/jsx-runtime";
function Minus(props) {
    const { height, width } = props;
    return (_jsx("svg", { ...props, width: height ?? 14, height: width ?? 14, viewBox: "0 0 14 14", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", children: _jsx("g", { id: "icon-minus-bare", stroke: "none", strokeWidth: "1", fillRule: "evenodd", children: _jsx("rect", { id: "Rectangle", x: "-7.28306304e-13", y: "6", width: "14", height: "2", rx: "1" }) }) }));
}
Minus.defaultProps = {
    fill: '#fff',
};
export default Minus;
